import { render, staticRenderFns } from "./MouseCoordsDisplay.vue?vue&type=template&id=0cb99574&scoped=true&"
import script from "./MouseCoordsDisplay.vue?vue&type=script&lang=ts&"
export * from "./MouseCoordsDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./MouseCoordsDisplay.vue?vue&type=style&index=0&id=0cb99574&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb99574",
  null
  
)

export default component.exports